import clsx from 'clsx'
import React from 'react'

const FormButton = ({ isSubmitting, text, disabled = false, testId }) => {
  return (
    <button
      data-testid={testId}
      className={clsx(
        'mt-px w-full h-[34px] taller:h-[40px] text-white text-sm taller:text-base rounded-xl hover:bg-blue-hover transition duration-100 active:shadow-[inset_0px_0px_14px_5px_#00000020] flex justify-center items-center',
        {
          'bg-blue': !isSubmitting && !disabled,
          'bg-white/50 pointer-events-none': isSubmitting || disabled,
        }
      )}
      type="submit"
      disabled={isSubmitting || disabled}
      aria-disabled={isSubmitting || disabled}
    >
      {isSubmitting ? (
        <img
          className="h-[34px] taller:h-[40px]"
          src="/assets/images/button-loader.svg"
          alt=""
        ></img>
      ) : (
        text
      )}
    </button>
  )
}

export default FormButton
